import type { cs } from "./cs"

export const de: typeof cs = {
    translation: {
        minimumStayDetail: {
            minimum_one: 'Die Mindestdauer der Reservierung beträgt {{count}}\u00a0Stunde.',
            minimum_few: 'Die Mindestdauer der Reservierung beträgt {{count}}\u00a0Stunden.',
            minimum_many: 'Die Mindestdauer der Reservierung beträgt {{count}}\u00a0Stunden.',
            minimum_other: 'Die Mindestdauer der Reservierung beträgt {{count}}\u00a0Stunden.',
            until: 'Sie können daher bis {{endsAt}} parken.',
            untilMidnight: 'Sie können daher bis Mitternacht parken.',
            untilWeekday: 'Sie können daher bis {{weekday}} um {{endsAt}} parken.',
        },
        minimumStayPrice: {
            unavailable: 'Der Preis konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
            availabilityUnavailable: 'Die Verfügbarkeit konnte nicht geprüft werden. Bitte versuchen Sie es erneut.',
            duration_one: 'Preis für {{count}} Stunde.',
            duration_few: 'Preis für {{count}} Stunden.',
            duration_many: 'Preis für {{count}} Stunden.',
            duration_other: 'Preis für {{count}} Stunden.',
            until: 'Sie können bis {{endsAt}} parken.',
            untilMidnight: 'Sie können bis Mitternacht parken.',
            untilWeekday: 'Sie können bis {{weekday}} um {{endsAt}} parken.',
            weekdays: {
                0: 'Sonntag',
                1: 'Montag',
                2: 'Dienstag',
                3: 'Mittwoch',
                4: 'Donnerstag',
                5: 'Freitag',
                6: 'Samstag',
            },
        },
        general: {
            bookNow: 'Reservieren',
            bookNowFor: 'Reservieren für',
            cannotBook: 'Reservierung nicht möglich',
            unavailable: 'Nicht buchbar',
            someGaragesInvalidPeriod: 'Einige Garagen sind für den gewählten Zeitraum nicht buchbar:',
            detail: 'Detail',
            czk: 'CZK',
            occupied: 'Besetzt',
            occupiedShort: 'Besetzt',
            min: 'Min.',
            hours: 'Stunden',
            hoursShortcut: 'St.',
            list: 'Liste',
            map: 'Karte',
            filters: 'Filter',
            hide: 'Schließen',
            garagesFound_one: 'Garage <strong>{{count}} gefunden</strong>',
            garagesFound_few: 'Garagen <strong>{{count}} gefuden</strong>',
            garagesFound_many: 'Garagen <strong>{{count}} gefunden</strong>',
            garagesFound_other: 'Garagen <strong>{{count}} gefunden</strong>',
            garagesAvailableLaterGeneric: 'Es scheint, dass viele Garagen zu dieser Zeit ausgebucht sind. Verschieben Sie den Reservierungsbeginn auf <strong>{{from}} - {{to}}</strong>, damit mehr Garagen verfügbar sind.',
            garagesAvailableAtTime_one: 'Es scheint, dass viele Garagen zu dieser Zeit ausgebucht sind. Verschieben Sie den Reservierungsbeginn auf <strong>{{time}}</strong>, dann ist <strong>{{count}} weitere Garage verfügbar</strong>.',
            garagesAvailableAtTime_few: 'Es scheint, dass viele Garagen zu dieser Zeit ausgebucht sind. Verschieben Sie den Reservierungsbeginn auf <strong>{{time}}</strong>, dann sind <strong>{{count}} weitere Garagen verfügbar</strong>.',
            garagesAvailableAtTime_many: 'Es scheint, dass viele Garagen zu dieser Zeit ausgebucht sind. Verschieben Sie den Reservierungsbeginn auf <strong>{{time}}</strong>, dann sind <strong>{{count}} weitere Garagen verfügbar</strong>.',
            garagesAvailableAtTime_other: 'Es scheint, dass viele Garagen zu dieser Zeit ausgebucht sind. Verschieben Sie den Reservierungsbeginn auf <strong>{{time}}</strong>, dann sind <strong>{{count}} weitere Garagen verfügbar</strong>.',
            moveToTimeWithCount_one: 'Um {{time}} starten (+{{count}} Garage)',
            moveToTimeWithCount_few: 'Um {{time}} starten (+{{count}} Garagen)',
            moveToTimeWithCount_many: 'Um {{time}} starten (+{{count}} Garagen)',
            moveToTimeWithCount_other: 'Um {{time}} starten (+{{count}} Garagen)',
            fromTime: 'Ab {{time}}',
            moveToTime: 'Um {{time}} starten',
            setStartToTime: 'Beginn auf {{time}} verschieben',
            startTimeMoved: 'Reservierungsbeginn auf {{time}} verschoben',
            undo: 'Rückgängig',
            garageAvailableLaterDetail: 'Diese Garage hat ab {{time}} freie Kapazität.',
            close: 'Schließen',
            lastPlacesAvailable: 'Letzte Plätze',
            boolean: {
                true: 'Ja',
                false: 'Nein'
            },
            phoneInput: {
                searchPlaceholder: "Eine Vorwahl auswählen",
            },
            resetChanges: 'Änderungen verwerfen',
            confirmFormClear: '‚Löschen des Formulars bestätigen',
            cancel: 'Abbrechen',
            confirm: 'Bestätigen',
        },
        filters: {
            showAvailable: 'Nur verfügbare Garagen zeigen',
            yesShow: 'Ja',
            priceRange: 'Preisspanne',
            carHeight: 'Höhe Ihres Fahrzeugs',
            carWidth: 'Breite Ihres Fahrzeugs',
            carLength: 'Länge Ihres Fahrzeugs',
            carWeight: 'Gewicht Ihres Fahrzeugs',
            sortBy: 'Sortieren nach',
            distance: 'Entfernung',
            price: 'Preis',
            parkingType: 'Typ',
            all: 'Alle',
            garage: 'Garage',
            parkingLot: 'Parkplatz',
            restrictions: 'Nur Garagen anzeigen, in denen erlaubt',
            electricAllowed: 'Elektroautos',
            lpgCngAllowed: 'LPG & CNG',
            motorbikesAllowed: 'Motorräder',
            remove: 'Alle Filter löschen',
            reset: 'Alle Filter löschen',
            showResults: 'Ergebnisse zeigen',
            noResultsMatch: 'Keine Garagen entsprechen diesen Filtern.',
        },
        search: {
            reset: 'Rücksetzen',
            edit: 'Verändern',
            search: 'Suchen',
            where: 'Wo möchten Sie parken?',
            wherePlaceholder: 'Stadt, Straße, Ort',
            whereEmpty: 'Keine Optionen',
            start: 'Von:',
            end: 'Bis:',
            label: 'Wann und wo parken?',
            reservationStart: 'Reservierung von',
            reservationEnd: 'Reservierung bis',
            reservationLength: 'Dauer der Reservierung',
            pricePerHour: 'Preis / Stunde',
            reservationExtendedLength: 'Dauer einer verlängerten Reservierung',            
            reservationDate: 'Reservierungsdatum',
            days_one: ' {{count}} Tag',
            days_few: ' {{count}} Tage',
            days_many: ' {{count}} Tage',
            days_other: ' {{count}} Tage',
            hours_one: ' {{count}} Stunde',
            hours_few: ' {{count}} Stunden',
            hours_many: ' {{count}} Stunden',
            hours_other: ' {{count}} Stunden',
            minutes_one: ' {{count}} Minute',
            minutes_few: ' {{count}} Minuten',
            minutes_many: ' {{count}} Minuten',
            minutes_other: ' {{count}} Minuten',
            selectDate: 'Start- und Enddatum auswählen',
            arrivalAfter: 'Ankommen nach',
            departureBefore: 'Abfahren vor',     
            selectStart: 'Wählen Sie das Startdatum im Kalender aus',
            selectEnd: 'Wählen Sie das Enddatum im Kalender aus',
            startInThePast: 'Der Beginn Ihrer Reservierung liegt in der Vergangenheit!',
            discountAvailable: 'Reservieren Sie mindestens 7 Tage und erhalten Sie <strong>15% Rabatt</strong> mit dem Code <strong>PREMIUM7</strong>.',
            invalidTimeRange: 'Wählen Sie einen gültigen Zeitraum, der nach Beginn der Reservierung endet.',
            defaultLocation: 'Parken in Prag',
            selectExtensionStart: 'Neues STARTDATUM im Kalender auswählen (oder aktuelles Startdatum auswählen).',
            selectExtensionEnd: 'Neues ENDDATUM im Kalender auswählen (oder aktuelles Enddatum auswählen).',
            extensionStartsTooLate: 'Die verlängerte Reservierung darf nicht später als die ursprüngliche Reservierung beginnen.',
            extensionEndsTooEarly: 'Die verlängerte Reservierung darf nicht früher als die ursprüngliche Reservierung enden.',
            extensionIntoThePast: 'Die Reservierung kann nicht in die Vergangenheit verlängert werden.',
            checkAvailability: 'Verfügbarkeit prüfen',
            sendExtensionRequest: 'Verlängerungsantrag senden',
            return: 'Zurück',
            extendReservation: 'Reservierung verlängern',
            extensionPossible: 'Es ist möglich, Ihre Reservierung zu verlängern!',
            extensionPrice: 'Preis für die Verlängerung: {{price}} CZK',
            originalExtensionPrice: 'Ursprünglicher Verlängerungspreis',
            extensionTotal: 'Gesamtpreis für die Verlängerung',
            payToContinue: 'Um die Verlängerung zu bestätigen, zahlen Sie bitte den Restbetrag.',
            toPaymentCTA: 'Zur Zahlung',
        },
        routes: {
            garages: 'garagen',
            reservations: 'reservierungen',
            reservations_steps: {
                reservation_time: 'reservierungszeit',
            },
            users: 'benutzer',
            signIn: 'anmeldung',
            register: 'registrierung',
            signOut: 'abmeldung',
        },
        reservations: {
            status: {
                booked: 'Künftig',
                current: 'Aktiv',
                elapsed: 'Abgelaufen',
                cancelled: 'Storniert',
                allocated: 'Zugewiesene',
            },
            general: {
                active: 'Aktive Reservierungen',
                all: 'Alle Reservierungen',
                noBooked: 'Sie haben keine aktiven oder zukünftigen Reservierungen.',
                noBookedCreate: 'Eine Reservierung erstellen',
                remaining: 'verbleibend',
            },
            filters: {
                sortBy: 'Sortieren nach',
                id: 'ID',
                startAt: 'Reservierungsbeginn',
                status: 'Status-Filter',
                all: 'Alle',
                active: 'Aktiv',
                elapsed: 'Abgelaufen',
                cancelled: 'Storniert',
                allocated: 'Zugewiesene',
            },
            table: {
                reservation: 'Reservierung',
                garage: 'Garage',
                unit: 'Platz',
                driver: 'Fahrer',
                licensePlate: 'Kennzeichen',
                phone: 'Handynummer',
                date: 'Datum',
                price: 'Preis',
                createdAt: 'Erstellt am',
                garageAndUnit: 'Garage and Platz',
                from: 'Von',
                to: 'Bis',
                phoneNumbers: 'Telefonnummern',
                cancelReservation: 'Stornieren',
                editDetails: 'Kennzeichen/Handynummer ändern',
                bookNextDay: 'Am nächsten Tag wiederholen',
                bookTomorrow: 'Ab morgen wiederholen',
                bookAgain: 'Die gleiche Garage buchen',
                paymentInProgress: 'Die Zahlung wird verarbeitet. Bitte warten Sie auf die Bestätigung.',
                changeUnitApprove: 'Um die Stellplatzänderung abzuschließen, bestätigen Sie bitte die Garagenordnung.',
                confirm: 'Bestätigen',
                openGarage: 'Garage anzeigen',
            },
            unpaid: {
                unfinishedReservation: {
                    alert: 'Um Ihre Reservierung abzuschließen, fahren Sie mit der Zahlung fort.',
                    button: 'Zur Zahlung',
                },
                prolongation: {
                    alert: 'Bitte zahlen Sie {{price}} {{currency}}, um die Reservierungsverlängerung abzuschließen.',
                    button: 'Verlängerung bezahlen',
                },
                changeUnit: {
                    alert: 'Bitte zahlen Sie {{price}} {{currency}}, um den Stellplatzwechsel abzuschließen.',
                    button: 'Stellplatzwechsel bezahlen',
                },
            },
            documents: {
                tickets: 'Tickets',
                invoices: 'Rechnungen',
                invoiceCorrections: 'Korrekturbelege',
                creditNotes: 'Gutschrifte',
                other: 'Andere Dokumente',
                termsOfService: 'Nutzungsbedingungen',
                privacyPolicy: 'Datenschutz',
                garageOperatingTerms: 'Garagenbetriebsordnung',
            },
            active: {
                open: 'Öffnen',
                slideToOpen: 'Ziehen zum Öffnen',
                entrance: 'Einfahrt',
                exit: 'Ausfahrt',
                reception: 'Rezeption',
                extend: 'Verlängern',
                cancel: 'Stornieren',
                confirm: 'Bestätigen',
                ending: 'Endet am',
                starting: 'Beginnt am',
                ended: 'Abgelaufen',
                cancelNotPossible: 'Eine Stornierung Ihrer Reservierung ist nicht möglich:',
                cancelSuccessful: 'Ihre Reservierung wurde erfolgreich storniert.',
            },
            edit: {
                save: 'Speichern',
                cancel: 'Stornieren',
                clear: 'Leeren',
                phoneNumber1: 'Handynummer 1',
                phoneNumber2: 'Handynummer 2',
                licensePlate: 'Kennzeichen',
            },
            cancel: {
                confirmation: 'Möchten Sie diese Reservierung wirklich stornieren?',
                detail: 'Nach der Stornierung der Reservierung ist es nicht mehr möglich, sie zu erneuern.',
                cancel: 'Reservierung stornieren',
                keep: 'Reservierung behalten',
            },
            empty: {
                title: 'Sie haben noch keine Reservierung vorgenommen',
                text: 'Erstellen Sie eine neue Reservierung. Hier können Sie dann alle Ihre Reservierungen sehen.'
            },
            reportOccupiedUnit: {
                button: 'Belegter Parkplatz',
                title: 'Belegten Parkplatz melden',
                subtitle: 'Steht jemand auf Ihrem zugewiesenen Parkplatz? Bitte füllen Sie die folgenden Angaben aus, und wir kümmern uns in Kürze darum.',
                buttonText: 'Melden',
                cancel: 'Abbrechen',
                offendantNumberPlate: 'Kennzeichen des fremden Fahrzeugs',
                yourReservationNumber: 'Ihre Reservierungsnummer',
                yourEmail: 'Ihre E-Mail-Adresse',
                stateCreated: 'Anfrage zur Änderung des zugewiesenen Parkplatzes erstellt',
                stateOpen: 'Anfrage zur Änderung des zugewiesenen Parkplatzes wird bearbeitet',
                stateClosed: 'Anfrage zur Änderung des zugewiesenen Parkplatzes wurde abgeschlossen',
            },
        },
        profile: {
            refetch: 'neu laden',
            languageSelector: 'Sprachauswahl',
            currencySelector: 'Währungsauswahl',
            signOut: 'Abmelden',
            userProfile: {
                title: "Benutzerprofil",
                edit_title: "Benutzerprofil ändern",
                edit_save: "Ändern",
                email: "E-Mail",
                userName: "Vor-und Nachname",
                phoneNumber1: "Handynummer 1",
                phoneNumber1Tooltip: "autorisiert zum Öffnen der Garage",
                phoneNumber2: "Handynummer 2",
                agreedToMarketing: "Zustimmen mit Marketing",
                edit_agreedToMarketing: "Marketing ermöglichen",
                prefillCheckoutInfo: "Checkout-Informationen vorausfüllen",
                edit_prefillCheckoutInfo: "Checkout-Informationen vorausfüllen",
            },
            invoiceDetails: {
                title: "Rechnungsdaten",
                edit_title: "Rechnungsdaten ändern",
                edit_save: "Ändern",
                empty: "Noch nicht eingetragen",
                invoice_title: "Firma",
                invoice_street: "Straße",
                invoice_city: "Stadt",
                invoice_zip_code: "PLZ",
                invoice_country: "Land",
                invoice_ic: "W-IdNr",
                invoice_dic: "USt-IdNr",
            },
            cars: {
                title: "Fahrzeuge",
                edit_title: "Fahrzeug ändern",
                edit_save: "Ändern",
                add_title: "Fahrzeug hinzufügen",
                add_confirm: "Hinzufügen",
                name: "Name",
                numberPlate: "Kfz-Kennzeichen",
                color: "Farbe",
                add: "Hinzufügen"
            }
        },
        checkout: {
            actions: {
                back: 'Zurück',
                toPaymentCTA: 'Zur Zahlung',
            },
            cancellationAlert: {
                heading: 'Kostenlose Stornierung jederzeit vor Beginn',
                bullet1: 'Sie können Ihre Reservierung jederzeit vor Beginn des Parkzeitraums stornieren.',
                bullet2: 'Die Stornierung können Sie in der App, über den Link in der Bestätigung E-Mail oder durch Kontaktaufnahme mit dem Kundenservice vornehmen.',
                bullet3: 'Nach Beginn des Reservierungszeitraums kann die Reservierung nicht mehr storniert werden, auch nicht teilweise.',
            },
            unsupportedIosApp: {
                title: 'MR.PARKIT aktualisieren, um fortzufahren',
                description: 'Diese Version von MR.PARKIT wird nicht mehr unterstützt. Aktualisieren Sie die App im App Store auf die neueste Version, um eine Reservierung zu erstellen oder zu bezahlen.',
                updateApp: 'Im App Store aktualisieren',
            },
            errors: {
                expiredTitle: 'Die Reservierung ist abgelaufen',
                expiredText: 'Diese Reservierung kann nicht mehr abgeschlossen werden. Bitte wahlen Sie erneut eine Garage aus und erstellen Sie eine neue Reservierung.',
                backToGarageList: 'Zuruck zur Garagenauswahl',
                unavailable: 'Die Checkout-Reservierung ist nicht mehr verfügbar. Bitte erstellen Sie eine neue Reservierung.',
            },
            booked: {
                title: 'Reservierung abgeschlossen',
                text: 'Diese Reservierung wurde bereits bezahlt und bestätigt.',
                myReservations: 'Zu meinen Reservierungen',
            },
            paymentResolution: {
                checking: 'Wir prüfen den Status Ihrer Zahlung. Bitte warten Sie.',
            },
            termsOfServiceHtml: '<checkboxLabel>Ich beantrage die Erbringung der Dienstleistung zum gebuchten Termin und Ich stimme </checkboxLabel><termsLink>den Nutzungsbedingungen</termsLink><checkboxLabel>, </checkboxLabel><privacyPolicyLink>den Schutz personenbezogener Daten</privacyPolicyLink><checkboxLabel> und </checkboxLabel><garageTermsLink>der Betriebsordnung</garageTermsLink><checkboxLabel> zu.</checkboxLabel>',
            sendSms: 'Ich kenne die Garage schon. Ich brauche keine SMS-Anleitung mehr und öffne sie ggf. mit der App.',
            disclaimer: {
                validation: {
                    required: 'Bitte bestätigen Sie die Bedingungen, um fortzufahren.',
                },
            },
            contactInfo: {
                heading: 'Kontakt',
                edit: 'Ändern',
                save: 'Speichern',
                cancel: 'Stornieren',
                clear: 'Leeren',
                name: 'Vor-und Nachname',
                email: 'E-Mail',
                emailSuggestion: 'Meinten Sie {{email}}?',
                phoneNumber1: 'Handynummer 1',
                phoneNumber2: 'Handynummer 2',
                invoiceHeading: 'Rechnungsdaten',
                invoiceTitle: 'Firma',
                mandatoryInvoiceTitle: 'Name/Firmenname',
                invoiceStreet: 'Straße',
                invoiceCity: 'Stadt',
                invoiceZipCode: 'PLZ',
                invoiceCountry: 'Land',
                countryNoOptions: 'Kein passendes Land',
                invoiceIc: 'W-IdNr',
                invoiceDic: 'USt-IdNr',
                addPhoneNumber: 'Weitere Telefonnummer hinzufügen',
                additionalPhoneInfo: 'Diese Telefonnummern sind zum Öffnen der Garage per Anruf autorisiert.',
                invoiceRequest: 'Ein normaler Steuerbeleg reicht mir nicht aus - ich benötige eine Rechnung für die Firmenbuchhaltung.',
                validation: {
                    required: 'Bitte füllen Sie dieses Feld aus.',
                    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
                    invalidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein.',
                },
            },
            vehicleInfo: {
                heading: 'Fahrzeug',
                edit: 'Ändern',
                save: 'Speichern',
                cancel: 'Stornieren',
                clear: 'Leeren',
                numberPlate: 'Kfz-Kennzeichen',
                carColor: 'Farbe',
                addNow: 'Jetzt hinzufügen',
                addLater: 'Später hinzufügen',
                savedCarsLabel: 'Fahrzeug auswählen',
                customOption: 'Andere...',
                addLaterSelected: 'Ich füge es später in der App hinzu',
                addLaterDescription: 'Das Kennzeichen können Sie jederzeit vor der Ankunft in der App ergänzen.',
                validation: {
                    required: 'Bitte füllen Sie dieses Feld aus.',
                },
            },
            discountCode: {
                // heading: 'Rabattcode',
                label: 'Rabattcode',
                apply: 'Anwenden',
                addCode: 'Rabattcode hinzufügen',
                changeCode: 'Anderen eingeben',
                removeCode: 'Rabattcode entfernen',
                applied: 'Rabattcode {{code}} wurde angewendet',
                appliedPercentage: 'Rabattcode {{code}} wurde angewendet - {{discount}}% Rabatt',
                appliedAmount: 'Rabattcode {{code}} wurde angewendet - Rabatt {{discount}} CZK',
                validation: {
                    required: 'Bitte geben Sie einen Rabattcode ein.',
                },
            },
            benefitCodePayment: {
                reveal: 'Mit Vorteilscode reservieren',
                label: 'Vorteilscode',
                placeholder: 'Vorteilscode auswählen',
                submit: 'Mit Vorteilscode reservieren',
                cancel: 'Stornieren',
                validation: {
                    required: 'Bitte wählen Sie einen Vorteilscode aus.',
                },
            },
            extensionAlert: {
                heading_one: 'Reservierung auf {{count}}\u00a0Stunde verlängert',
                heading_few: 'Reservierung auf {{count}}\u00a0Stunden verlängert',
                heading_many: 'Reservierung auf {{count}}\u00a0Stunden verlängert',
                heading_other: 'Reservierung auf {{count}}\u00a0Stunden verlängert',
                explanation: 'Wir haben Ihre Reservierung daher automatisch verlängert.',
                until: 'Zum gleichen Preis können Sie bis {{endsAt}} parken.',
                untilMidnight: 'Zum gleichen Preis können Sie bis Mitternacht parken.',
                untilWeekday: 'Zum gleichen Preis können Sie bis {{weekday}} um {{endsAt}} parken.',
            },
            orderSummary: {
                start: 'Beginn',
                end: 'Ende',
                duration: 'Dauer',
                originalPrice: 'Ursprungspreis',
                discount: 'Rabatt',
                total: 'Insgesamt',
                identificationNumber: 'W-IdNr.',
                vatPayer: 'Mehrwertsteuerzahler',
                notVatPayer: 'Nicht umsatzsteuerpflichtig',
                vatIncluded: 'mit MwSt.',
            },
            paymentResult: {
                missingPaymentId: 'Die Zahlungsreferenz fehlt.',
                missingReservationToken: 'Der Checkout-Kontext fehlt. Bitte gehen Sie zum Checkout zuruck und versuchen Sie es erneut.',
                genericError: 'Die Zahlung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
                redirectingToStripe: 'Weiterleitung zu Stripe…',
                continueToStripeHostedPayment: 'Weiter zur Stripe-hosted Zahlung',
                continueToPayment: 'Weiter zur Zahlung',
                backToHomepage: 'Zurück zur Startseite',
                backToCheckout: 'Zurück zum Checkout',
            },
        },
        success: {
            newsletterBanner: {
                title: 'Verpassen Sie keine Neuigkeiten und Sonderangebote',
                button: 'Neuigkeiten abonnieren',
                success: 'Vielen Dank für Ihre Anmeldung.',
                error: 'Die Anmeldung für unsere Neuigkeiten ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
            },
            appBanner: {
                title: 'Machen Sie das Parken noch einfacher mit unserer mobilen App',
                feature1: 'Reservierungen einfach bearbeiten oder stornieren',
                feature2: 'Garage bequem per Knopfdruck statt per Anruf öffnen',
                feature3: 'Noch schneller reservieren ohne erneutes Ausfüllen Ihrer Daten',
                feature4: 'Alle Abrechnungsunterlagen an einem Ort',
                androidAlt: 'Auf Android installieren',
                iphoneAlt: 'Auf dem iPhone installieren',
                visualAlt: 'QR-Code und Vorschau der mobilen App von Mr. Parkit',
            },
            congratulations: {
                title: 'Erfolgreiche Reservierung" Danke.',
                imageAlt: 'Illustratives Bild der Reservierung',
                text: 'Wir haben einen Parkschein mit den Details Ihrer Reservierung an die angegebene E-Mail-Adresse geschickt. Für Ihren Komfort haben wir auch alles in einer SMS-Nachricht an die von Ihnen angegebenen Telefonnummern gesendet. Der Parkplatz muss spätestens am Ende der Reservierung verlassen werden!',
                textWithoutSms: 'Wir haben einen Parkschein mit den Details Ihrer Reservierung an die angegebene E-Mail-Adresse geschickt. Ihre Reservierung können Sie unter „Meine Reservierungen“ verwalten. Der Parkplatz muss spätestens am Ende der Reservierung verlassen werden!',
                myReservationsLink: 'Weiter zu meinen Reservierungen',
            },
            prolongation: {
                congratulations: {
                    title: 'Reservierung erfolgreich verlängert',
                    imageAlt: 'Illustratives Bild einer erfolgreichen Reservierungsverlängerung',
                    text: 'Ihre Reservierungsverlängerung wurde erfolgreich bestätigt. Die aktualisierte Bestätigung senden wir Ihnen per E-Mail und SMS.',
                },
                failed: {
                    title: 'Verlängerung der Reservierung fehlgeschlagen',
                    text: 'Die Zahlung für die Reservierungsverlängerung konnte nicht bestätigt werden. Bitte versuchen Sie es erneut über das Reservierungsdetail.',
                },
                pending: {
                    title: 'Warten auf die Bestätigung der Verlängerungszahlung',
                    imageAlt: 'Illustratives Bild einer ausstehenden Reservierungsverlängerung',
                    text: 'Die Zahlung für die Reservierungsverlängerung wurde noch nicht bestätigt. Bitte warten Sie auf den Abschluss.',
                },
                returnLink: 'Zurück zur Reservierung',
            },
            changeUnit: {
                congratulations: {
                    title: 'Stellplatz erfolgreich geändert',
                    imageAlt: 'Illustratives Bild eines erfolgreichen Stellplatzwechsels',
                    text: 'Die Zahlung für Ihren Stellplatzwechsel wurde bestätigt. Die aktualisierte Bestätigung senden wir Ihnen per E-Mail und SMS.',
                },
                failed: {
                    title: 'Zahlung für den Stellplatzwechsel fehlgeschlagen',
                    text: 'Die Zahlung für den Stellplatzwechsel konnte nicht bestätigt werden. Bitte versuchen Sie es erneut über das Reservierungsdetail.',
                },
                pending: {
                    title: 'Warten auf die Bestätigung der Zahlung für den Stellplatzwechsel',
                    imageAlt: 'Illustratives Bild eines ausstehenden Stellplatzwechsels',
                    text: 'Die Zahlung für den Stellplatzwechsel wurde noch nicht bestätigt. Bitte warten Sie auf den Abschluss.',
                },
                returnLink: 'Zurück zur Reservierung',
            },
            failed: {
                title: 'Reservation failed',
                imageAlt: 'Illustrative picture of a failed reservation',
                text: 'The most probable reason is that took you over 30 minutes to finish payment and the reservation expired in the meantime. We will cancel the payment and refund your money. Please try to repeat the reservation.',
                repeatLink: 'Repeat reservation',
            },
            pending: {
                title: 'Warten auf Zahlungsbestätigung',
                imageAlt: 'Illustrative picture of a pending reservation',
                text: 'Die Zahlung ist noch nicht bestätigt. Bitte warten Sie auf die Bestätigung. Sobald die Zahlung bestätigt ist, senden wir Ihnen eine Bestätigung per E-Mail und SMS.',
                repeatLink: 'Repeat reservation',
            },
            summary: { 
                title: 'Reservierungsbestätigung',
                continueToMyReservations: 'Bitte gehen Sie zu Meine Reservierungen, um die Reservierungsdetails anzuzeigen.',
                debugFetchErrorsIntro: 'Beim Laden der Reservierungsdetails in dieser Ansicht sind Fehler aufgetreten:',
            },
            reservationSummary: {
                totalPrice: 'Insgesamt',
                vatIncluded: 'inkl. MwSt.',
                email: 'E-Mail',
                name: 'Vor-und Nachname',
                numberPlate: 'Kfz-Kennzeichen',
                carColor: 'Farbe',
                floorWithNumber:'Etage/Parkplatznummer',
                phoneNumber:'Handynummer',
                phoneNumber2:'Handynummer 2',
            }
        },
        garage: {
            car_dimensions: {
                title: 'Maximale Fahrzeugabmessungen',
                titleWithWeight: 'Maximale Fahrzeugabmessungen und maximales Gewicht',
                height: 'Höhe',
                length: 'Länge',
                weight: 'Gewicht',
                width: 'Breite',
            },
            showLess: 'Weniger anzeigen',
            showMore: 'Mehr anzeigen',
            mainBenefits: {
                first: 'Wiederholte Ein- und Ausfahrt',
                second: 'Anweisung per SMS und E-Mail',
                third: 'Einfache Stornierung und Veränderug der Reservierung',
            },
            openOnMap: "Navigieren",
            showInstructions: "Wichtige Hinweise",
            instructionsHeading: "Wichtige Hinweise zur Ankunft/Abfahrt aus der Garage",
            benefits: {
                title: 'Parameter',
                list: {
                    '10_minutes_form_city_center': 'Zentrum bis 10 min entfernt',
                    '15_minutes_from_city_center': 'Zentrum bis 15 min entfernt',
                    '5_minutes_form_city_center': 'Zentrum bis 5 min entfernt',
                    call_reception: 'Bitte rufen Sie die Rezeption bei der Ankunft an.',
                    cctv: 'Videoüberwachung',
                    cctv_at_entrance: 'Videoüberwachung an der Einfahrt',
                    city_center: 'Stadtzentrum',
                    historic_city_center: 'Altstadt',
                    charging_station: 'Ladestationen für Elektrofahrzeuge',
                    licence_plate_validation: 'Öffnen Sie die Schranke mit Kennzeichenerkennung',
                    limited_vehicle_dimensions: 'Maximale Fahrzeuggrösse',
                    main_reception: 'Der Zugang zur Garage erfolgt über die Hauptrezeption in der Lobby - erst dann können Sie in die Garage einfahren.',
                    nonstop_operation: 'Non-stop Betrieb',
                    nonstop_reception: 'Non-stop Rezeption',
                    nonstop_service: 'Non-stop Betrieb',
                    number_plate_recognition: 'Die Videokamera liest Ihr KfZ-Zeichen und öffnet die Schranke',
                    open_gate_by_attendant: 'Rezeption wird das Tor öffnen',
                    open_gate_by_phone: 'Das Garagentor öffnen Sie per Handy',
                    parking_for_disabled: 'Parken für Behinderte',
                    security_system: 'Sicherheitssystem',
                    subway_availability: 'Metro in der Nähe',
                    tram_availability: 'Straßenbahn in der Nähe',
                    wc: 'WC',
                },
            },
            prohibitions: {
                title: 'Verbote',
                list: {
                    lpg_cng_not_allowed: 'Keine Einfahrt für CNG und LPG',
                    electric_car_not_allowed: 'Parken von Elektroautos verboten',
                    motorbikes_not_allowed: 'Kein Motorrad Parkplatz',
                },
            },
            garage_videos: {
                title: 'Videogalerie',
            },
            faq: {
                title: 'Häufige Fragen',
            },
            reservationSummary: {
                minimumStay: {
                    first: 'Die Mindestreservierungsdauer beträgt hier',
                    second: 'Stunden',
                },
            },
            confirmationModal: {
                maxDimensionsTitle: 'Achtung',
                cancel: 'Stornieren',
                complete: 'Reservieren',
            }
        },
        loginCrossroads: {
            login: "Anmelden",
            createAccount: "Konto erstellen",
        },
        pwa: {
            search: 'Suchen',
            myReservations: 'Meine Reservierungen',
            profile: 'Profil',
            myReservationsNoUser: 'Um Reservierungen zu verwalten und Garagen zu öffnen, müssen Sie sich einloggen:',
            profileNoUser: 'Um Ihr Profil, Ihre Fahrzeuge und Ihre Rechnungen zu verwalten, müssen Sie sich einloggen:'
        },
        error: {
            heading: 'Ups! :(',
            title: 'Ein unerwarteter Fehler ist aufgetreten',
            titleEmbedded: 'Ein unerwarteter Fehler ist in dieser Ansicht aufgetreten – der Rest der Anwendung ist sehr wahrscheinlich nicht betroffen.',
            textEmbedded: 'Bitte versuchen Sie, zu einem anderen Tab zu wechseln oder die App neu zu starten. Sie können uns auch über unsere Website oder unsere Hotline kontaktieren.',
            moreInfo: 'Hier sind weitere Details für die Entwickler:'
        },
        support: {
            heading: 'Kontakt',
            text: 'Während unserer Arbeitszeiten Mo–Fr 9:00–17:00 Uhr beantworten wir gerne Ihre Fragen. Außerhalb dieser Zeiten ist unsere Non-Stop-Hotline für dringende Anliegen zu aktuell laufenden Reservierungen erreichbar.',
            more: 'Mehr',
        },
    },
}
